module.exports = __webpack_public_path__ + "static/img/KAIDEN-McNAMARA.bcdbac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KAIDEN-McNAMARA.jpg
// module id = J/0A
// module chunks = 0